module.exports = __webpack_public_path__ + "img/see_no_evil_monkey.71a2204a.gif";